import { CloseButton, Col, Modal, Row } from 'react-bootstrap';
import { Button, Button as MyButton } from "./Button";
import { AbandonedVehicleReviewStatus, AbandonedVehicleStatus,  } from "../api/Network";
import { AbandonedVehicleSituation, DisplayVehicleType, showDisplayVehicleSituation, showDisplayVehicleType } from "../loaders/abandonedVehicleCompressed";
import React from "react";
import { getReviewStatusIcon, getSituationIcon, getVehicleTypeIcon, IconResult } from "./AbandonedVehicleStatusIconNew";
import { pluralize } from "../api/Plural";
import { SealXmark } from "../svg/Seals";
import { showAbandonedVehicleReviewStatus } from "../api/EnumUtils";

export interface CompareFilter {
    typeFilters:         Array<DisplayVehicleType        | null>;
    situationFilters:    Array<AbandonedVehicleSituation | null>;
    statusFilters:       Array<AbandonedVehicleStatus>;
    reviewStatusFilters: Array<AbandonedVehicleReviewStatus | null>;
    areaFilters:         Array<number | null>;
    confThr:             number;
    similarityThr:       number;
}

interface CompareFilterProps {
    vehicleCount: number;
    filters:      CompareFilter;
    setFilters:   ( filters: CompareFilter ) => void;
}

interface StatusFilterModalProps extends CompareFilterProps {
    show:        boolean;
    onHide:      () => void;
    fullscreen?: true | string | 'sm-down' | 'md-down' | 'lg-down' | 'xl-down' | 'xxl-down';
}

const vehicleSits = [
    AbandonedVehicleSituation.Street,
    AbandonedVehicleSituation.Lot,
    AbandonedVehicleSituation.Drive
];

const vehicleTypes = [
    null,
    DisplayVehicleType.Car,
    DisplayVehicleType.Pickup,
    DisplayVehicleType.Suv
];

const statuses = [  
    AbandonedVehicleStatus.ReviewedVerified,
    AbandonedVehicleStatus.Candidate,
    AbandonedVehicleStatus.ReviewedUnsure,
 // AbandonedVehicleStatus.ReviewedRejected,
 // AbandonedVehicleStatus.ReviewedRejectedIdentity,
    AbandonedVehicleStatus.ReviewedRejectedMoved,
 // AbandonedVehicleStatus.ReviewedRejectedNotAVehicle,
 // AbandonedVehicleStatus.ReviewedRejectedDeparted,
 // AbandonedVehicleStatus.ReviewedRejectedArrived,
];

const reviewStatuses = [  
    AbandonedVehicleReviewStatus.New,
    AbandonedVehicleReviewStatus.NotActionable,
    AbandonedVehicleReviewStatus.Actionable
];

interface FilterButtonProps<T> {
    filter:    Array<T>;
    value:     T;
    label:     string;
    onChange:  ( values: Array<T> ) => void;
    getIcon:   ( value:  T ) => IconResult;
    cols?:     number;
}

const buttonBase = "px-2 mb-2 w-100 d-flex align-items-center justify-content-center bg-body text-muted";
const buttonOn   = "border-2";
const buttonOff  = "border-2 text-body-tertiary border-secondary-subtle";
export function FilterButton<T extends string | number | null>( { filter, value, label, onChange, getIcon, cols = 3 }: FilterButtonProps<T> ) {
    const checked = filter.includes( value );
    const chg     = checked ? filter.filter( st => st !== value ) : [...filter, value];
    const { icon, size: iconSize, color: iconColor, borderColor = "border-primary" } = getIcon( value );
    const color  = checked ? iconColor : "text-body-secondary";
    const iconEl = React.cloneElement( icon, { className: `${color} ${iconSize}` } );
    const extraButtonClss = checked ? buttonOn : buttonOff;
    return <Col xs={cols} key={value}>
        <Button
            style={{ display: "grid", gridTemplateColumns: "min-content 100fr", gap: "0.25em" }}
            className={`${buttonBase} ${extraButtonClss} ${borderColor}`}
            onClick={() => onChange( chg )}>
            <div>{iconEl}</div>
            <div className="text-start">{label}</div>
        </Button>
    </Col>;
}

export function FilterBody( { vehicleCount, filters, setFilters }: CompareFilterProps ) {
    const areaCount   = filters.areaFilters.length;
    const areaWord    = pluralize( "Area",    "Areas", areaCount );
    const vehicleWord = pluralize( "Vehicle", "Vehicles", vehicleCount );
    const qualifier   = filters.areaFilters.length > 0 ? `in ${areaCount} ${areaWord}` : ``;
    return <div>
        <Row className="g-2 mb-2">
            {/* <VehicleSitButton cols={1} sit={null} filter={filter} setFilters={setFilters} /> */}
            {vehicleSits.map( si =>
                <FilterButton<AbandonedVehicleSituation | null>
                    key={si}
                    value={si}
                    label={showDisplayVehicleSituation( si )}
                    filter={filters.situationFilters}
                    onChange={ x => setFilters( ({ ...filters, situationFilters: x }) ) } 
                    getIcon={getSituationIcon} 
                    cols={4} />)}
        </Row>
        {/* <Row className="g-2 mb-2">
            {vehicleTypes.map( type => 
                <FilterButton<DisplayVehicleType | null>
                    key={type}
                    value={type}
                    label={showDisplayVehicleType( type )}
                    filter={filters.typeFilters}
                    onChange={ x => setFilters( ({ ...filters, typeFilters: x }) ) } 
                    getIcon={getVehicleTypeIcon} 
                    cols={3} />)}
        </Row> */}
        <Row className="g-2 mb-2">
            {reviewStatuses.map( st => 
                <FilterButton<AbandonedVehicleReviewStatus | null>
                    key={st}
                    value={st}
                    label={showAbandonedVehicleReviewStatus( st )}
                    filter={filters.reviewStatusFilters}
                    onChange={ x => setFilters( ({ ...filters, reviewStatusFilters: x }) ) } 
                    getIcon={getReviewStatusIcon}
                    cols={4} />)}
        </Row>
        <Row>
            <Col className="w-100 d-flex align-items-center justify-content-center mb-2 gap-2">
                {<>
                    <div className="px-2 fs-6 flex-grow-1">{vehicleCount} {vehicleWord} {qualifier}</div>
                    {areaCount > 0 && <Button className="border-2" onClick={ () => setFilters( { ...filters, areaFilters: [] } ) }>
                        Show All Areas
                    </Button>}
                </>}
            </Col>
        </Row>
    </div>;
}

export function StatusFilterModal( { vehicleCount, show, onHide, filters, setFilters, fullscreen }: StatusFilterModalProps ) {
    const handleClose = () => {
        onHide();
    };

    return (
        <Modal show={show} onHide={handleClose} onEscapeKeyDown={handleClose} centered fullscreen={fullscreen}>
            <Modal.Header closeButton>
                <Modal.Title>Filters</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FilterBody vehicleCount={vehicleCount} filters={filters} setFilters={setFilters} />
                <div className="d-flex gap-2">
                    <MyButton className="w-100" onClick={onHide}>
                        Close
                    </MyButton>
                </div>
            </Modal.Body>
        </Modal>
    );
}